module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', {
    attrs: {
      "user-signup": ""
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : (!_vm.loading && _vm.complete && !_vm.valid) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Confirm Email Change")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])])], 1) : (!_vm.loading && _vm.complete && _vm.valid) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Confirm Email Change")]), _vm._v(" "), _c('p', [_vm._v("Your email has been updated successfully.")])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f20e0f1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/confirm-email-change/confirm-email-change.vue
// module id = 699
// module chunks = 0